import React, {useEffect, useState, useRef} from "react";
import JoditEditor from "jodit-react";
import {Link} from "react-router-dom";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import articleService from "../../../services/articles.service";
import {useNavigate} from 'react-router-dom';

const AddArticles = () => {
    const [content, setContent] = useState();
    const [category, setCategory] = useState([]);
    const editor = useRef(null);
    const config = {
        readonly: false,
        height: "80vh",

        disablePlugins: ["powered-by-jodit", "file"],
    };
    const {
        register,
        handleSubmit,
        formState: {isSubmitting, errors},
    } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        //get category list
        articleService
            .getArticlesCategory()
            .then((res) => {
                setCategory(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onSubmit = async (data) => {
        const newData = {...data, content: content};
        try {
            await articleService.saveArticles(newData);
            toast.success("Article Saved", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            setTimeout(() => {
                navigate('/articles');
            }, 2000);
        } catch (err) {
            toast.error("Error while adding Article", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.log(err);
        }
    };
    return (
        <>
            {/* Header Section */}
            <div className="container container-xxl">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <i className="bi bi-file-medical fs-3 text-primary me-3"></i>
                        <h1 className="h4 mb-0">New Article</h1>
                    </div>
                    <Link to="/articles" className="btn btn-outline-secondary btn-sm">
                        <i className="bi bi-chevron-left me-1"></i> Back to Articles
                    </Link>
                </div>
            </div>

            {/* Main Content */}
            <main className="container container-xxl mt-4">
                <div className="row g-4">
                    {/* Editor Column (70% width) */}
                    <div className="col-lg-8">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-0">
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    onChange={(newContent) => {
                                    }}
                                    onBlur={(newContent) => setContent(newContent)}
                                    config={config}
                                    tabIndex={1}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Sidebar Form (30% width) */}
                    <div className="col-lg-4">
                        <div className="card border-0 shadow-sm sticky-top" style={{top: '20px'}}>
                            <div className="card-header bg-white border-bottom">
                                <h5 className="mb-0">Article Details</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {/* Title Field */}
                                    <div className="mb-3">
                                        <div className="p-2"></div>
                                        <label className="form-label fw-semibold">
                                            Title <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            {...register("title", {required: true})}
                                            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                            placeholder="Enter article title"
                                        />
                                        {errors.title && (
                                            <div className="invalid-feedback">Title is required</div>
                                        )}
                                    </div>

                                    {/* Status Field */}
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Status</label>
                                        <select {...register("status")} className="form-select">
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </div>

                                    {/* Category Field */}
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Category</label>
                                        <select
                                            {...register("articleCategoryId")}
                                            className="form-select"
                                        >
                                            {category?.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Summary Field */}
                                    <div className="mb-4">
                                        <label className="form-label fw-semibold">Summary</label>
                                        <textarea
                                            className="form-control"
                                            {...register("summary")}
                                            rows="8"
                                            placeholder="Brief article summary..."
                                        ></textarea>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Saving...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-floppy-fill me-2"></i> Save Article
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default AddArticles;
